/* eslint-disable */
import React from 'react';
import {  useLocation, useHistory } from 'react-router-dom';
import {  Nav, NavItem } from 'react-bootstrap';

import { useSelector } from 'react-redux';

const Menu = () => {
  const location = useLocation();
  const history = useHistory();

  const reports = useSelector((state) => state.reports);
  const reportsMenu = reports.mainConfig?.reports || [];

  const onClickReport = (item) => {
    history.push(item.url.replace('/admin', ''));
  };

  return (
    <Nav bsStyle="pills" className="tabs">
      {reportsMenu.map((item) => {
        const { title, code } = item;
        return (
          <NavItem
            key={code}
            active={location.pathname.includes(item.url.replace('/admin', ''))}
            title={title}
            onSelect={() => onClickReport(item)}
          >
            <span>{item.title}</span>
          </NavItem>
        );
      })}
    </Nav>
  );
};

export default Menu;
